import React from 'react';
import PropTypes from 'prop-types';
import YoutubeEmbeded from './YoutubeEmbeded';
import { getYouTubeID, booleanToNumber } from './helpers';
import { VIDEO_WRAPPER_CLASS_NAME } from '../../../../constants';

const YouTubeProvider = ({ url, autoplay, loop, placeholderOnly, imageData }) => {
  const videoId = getYouTubeID(url);

  if (!videoId) return null;
  const params = `loop=${booleanToNumber(loop)}`;

  return (
    <div className={VIDEO_WRAPPER_CLASS_NAME}>
      <YoutubeEmbeded
        autoplay={autoplay}
        videoId={videoId}
        params={params}
        placeholderOnly={placeholderOnly}
        imageData={imageData}
      />
    </div>
  );
};

YouTubeProvider.propTypes = {
  url: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  placeholderOnly: PropTypes.bool,
  imageData: PropTypes.object
};

YouTubeProvider.defaultProps = {
  autoplay: false,
  loop: false,
  placeholderOnly: false,
  imageData: {}
};

export default YouTubeProvider;
